(function () {
  'use strict';

  function getQuickViewButtons(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const buttons = Array.from(scope.querySelectorAll('[data-product-card-quick-view]'));
    if (scope.matches && scope.matches('[data-product-card-quick-view]')) buttons.unshift(scope);
    return buttons;
  }

  // Button colors and radius come from the Quickview section's own style block
  // (snippets/quick-view-modal.liquid); only availability is synced here.
  function syncQuickViewButtons(root) {
    const hasQuickView = Boolean(document.querySelector('[data-quick-view-modal]'));

    getQuickViewButtons(root).forEach((button) => {
      button.hidden = !hasQuickView;
      button.setAttribute('aria-hidden', hasQuickView ? 'false' : 'true');
      if (!hasQuickView) {
        button.dataset.loading = 'false';
      }
    });
  }

  function setProductCardGalleryIndex(gallery, index) {
    if (!gallery) return;
    const slides = Array.from(gallery.querySelectorAll('[data-product-card-gallery-slide]'));
    if (!slides.length) return;
    const normalized = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === normalized;
      slide.style.transform = `translate3d(${(slideIndex - normalized) * 100}%, 0, 0)`;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    gallery.querySelectorAll('[data-product-card-gallery-indicator]').forEach((indicator, indicatorIndex) => {
      indicator.classList.toggle('is-active', indicatorIndex === normalized);
    });
  }

  function initProductCardMediaGallery() {
    if (window.AxiomProductCardMediaGalleryBound) return;
    window.AxiomProductCardMediaGalleryBound = true;

    document.addEventListener('pointermove', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const gallery = event.target.closest('[data-product-card-hover-effect="media_gallery"] [data-product-card-media-gallery]');
      if (!gallery) return;
      const slides = gallery.querySelectorAll('[data-product-card-gallery-slide]');
      if (slides.length < 2) return;
      gallery._productCardPointerX = event.clientX;
      if (gallery._productCardPointerFrame) return;
      gallery._productCardPointerFrame = requestAnimationFrame(() => {
        gallery._productCardPointerFrame = null;
        const rect = gallery.getBoundingClientRect();
        if (!rect.width) return;
        const position = Math.max(0, Math.min(.9999, (gallery._productCardPointerX - rect.left) / rect.width));
        setProductCardGalleryIndex(gallery, Math.floor(position * slides.length));
      });
    });

    document.addEventListener('pointerout', (event) => {
      const gallery = event.target.closest('[data-product-card-media-gallery]');
      if (!gallery || (event.relatedTarget && gallery.contains(event.relatedTarget))) return;
      if (gallery._productCardPointerFrame) {
        cancelAnimationFrame(gallery._productCardPointerFrame);
        gallery._productCardPointerFrame = null;
      }
      setProductCardGalleryIndex(gallery, 0);
    });
  }

  function cancelProductCardGalleryFrames(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-product-card-media-gallery]').forEach((gallery) => {
      if (!gallery._productCardPointerFrame) return;
      cancelAnimationFrame(gallery._productCardPointerFrame);
      gallery._productCardPointerFrame = null;
    });
  }

  function initProductCardSwatches() {
    if (window.AxiomProductCardSwatchesBound) return;
    window.AxiomProductCardSwatchesBound = true;

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-product-card-swatch]');
      if (!swatch) return;

      const card = swatch.closest('[data-product-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      card.querySelectorAll('[data-product-card-swatch]').forEach((button) => {
        const active = button === swatch;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const variantUrl = swatch.dataset.variantUrl;
      if (variantUrl) {
        card.querySelectorAll('[data-product-card-link]').forEach((link) => {
          link.setAttribute('href', variantUrl);
          if (link.matches('[data-mobile-quick-view-trigger]')) {
            link.dataset.productUrl = variantUrl;
          }
        });
      }

      const quickViewTrigger = card.querySelector('[data-product-card-quick-view]');
      if (quickViewTrigger && swatch.dataset.productUrl) {
        quickViewTrigger.dataset.productUrl = swatch.dataset.productUrl;
      }

      const image = card.querySelector('.product-card-link img:not(.product-card-image__hover)');
      if (image && swatch.dataset.imageSrc) {
        image.src = swatch.dataset.imageSrc;
        if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
      }

      const imageWrap = card.querySelector('.product-card-image');
      if (imageWrap && swatch.dataset.imageSrc) {
        imageWrap.classList.add('product-card-image--variant-selected');
      }

      setProductCardGalleryIndex(card.querySelector('[data-product-card-media-gallery]'), 0);

      const hoverImage = card.querySelector('.product-card-image__hover');
      if (hoverImage && swatch.dataset.imageSrc) {
        hoverImage.src = swatch.dataset.imageSrc;
        if (swatch.dataset.imageSrcset) hoverImage.srcset = swatch.dataset.imageSrcset;
      }

      const price = card.querySelector('[data-product-card-price]');
      if (price && swatch.dataset.priceHtml) {
        price.innerHTML = swatch.dataset.priceHtml;
      }

      if (window.AxiomProductBadges) {
        window.AxiomProductBadges.update(card, {
          productId: card.dataset.productId,
          available: swatch.dataset.variantAvailable === 'true',
          price: Number(swatch.dataset.variantPrice || 0),
          compareAtPrice: Number(swatch.dataset.variantCompareAtPrice || 0),
          purchaseOptionLabel: swatch.dataset.variantPurchaseOptionLabel || '',
        });
      }
    });
  }

  function init(root) {
    initProductCardSwatches();
    initProductCardMediaGallery();
    syncQuickViewButtons(root);
  }

  window.AxiomProductCard = window.AxiomProductCard || {};
  window.AxiomProductCard.initialize = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    cancelProductCardGalleryFrames(event.target);
    if (event.target && event.target.querySelector && event.target.querySelector('[data-quick-view-modal]')) return;
    syncQuickViewButtons(document);
  });
  document.addEventListener('axiom:section-rendered', function (event) {
    init(event.detail && event.detail.container ? event.detail.container : event.target);
  });
})();
